// extracted by mini-css-extract-plugin
export default {"root":"Header__root--gHWkt","responsive":"Header__responsive--2hvIc","controlsWrapper":"Header__controlsWrapper--3jDI3"};